import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { File } from "../data/file";

@Injectable()
export class FileService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  filesUrl = "api/v2/files";

  constructor(private httpClient: HttpClient) {}

  get(filetype: string): Promise<File[]> {
    let url = `${this.filesUrl}?filetype=${filetype}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as File[])
      .catch(this.handleError);
  }

  getS3Config(): any {
    let url = `${this.filesUrl}/s3-config`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as any)
      .catch(this.handleError);
  }

  getFile(id: string): Promise<File> {
    const url = `${this.filesUrl}/${id}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as File)
      .catch(this.handleError);
  }

  delete(id: string): Promise<void> {
    const url = `${this.filesUrl}/${id}`;
    return this.httpClient
      .delete(url, { headers: this.httpHeaders })
      .toPromise()
      .then(() => null)
      .catch(this.handleError);
  }

  create(): Promise<File> {
    return this.httpClient
      .post(
        this.filesUrl,
        { title: "Untitled File" },
        { headers: this.httpHeaders }
      )
      .toPromise()
      .then((res) => res as File)
      .catch(this.handleError);
  }

  update(ad: File): Promise<File> {
    const url = `${this.filesUrl}/${ad.id}`;
    return this.httpClient
      .put(url, JSON.stringify(ad), { headers: this.httpHeaders })
      .toPromise()
      .then(() => ad)
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
